import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import useApplyFilters from '~/core/filters/hooks/useApplyFilters';

export const ActivityFilterControl = props => {
	const { toggleFilter } = useApplyFilters();
	const [filterOptions, setFilterOptions] = useState([]);
	const [isOpenedFilter, setOpenedFilter] = useState('false');

	const handleToggle = () => {
		setOpenedFilter(!isOpenedFilter);
	};

	useEffect(() => {
		if (props.filter == null || props.filter.items.length == 0) {
			return;
		}

		if (props.filter.id !== 11) {
			return null;
		}

		var list = [];

		for (let item of props.filter.items) {
			list.push(item);
		}

		setFilterOptions(list);
	}, [props.filter]);

	// Apply filter without page refresh...
	const handleFilterClick = (event, url) => {
		event.preventDefault();
		toggleFilter(url);
	};

	const renderFilterButtons = filterList => {
		var controls = [];
		// Render filters

		for (let fv of filterList) {
			// Category filter is a simple link
			let filterUrl = fv.url;

			// Check fv.chex for applying color rectangle, also check props.filter.tp to determine filter type
			// Check fv.sel to apply UI for showing filter selected
			controls.push(
				<div className={fv.sel ? 'sub-item choosen' : 'sub-item'} key={'activity-' + props.filter.id + '-' + fv.vl}>
					<Link
						className="flex-col"
						key={'lnk-bflt-' + fv.id}
						to={filterUrl}
						onClick={e => {
							handleFilterClick(e, filterUrl);
						}}></Link>
					<img src={fv.img1} alt={fv.vl} width="180" height="180" loading="lazy" style={{ width: '100%', height: 'auto' }} />
					<h4>{fv.vl}</h4>
				</div>
			);
		}

		return <>{controls}</>;
	};

	return <>{renderFilterButtons(filterOptions)}</>;
};

ActivityFilterControl.propTypes = {
	placeholder: PropTypes.string,
	filter: PropTypes.object
};
